/**
 * SF Symbol → Lucide 图标映射。
 *
 * iOS 端用 SF Symbol（symbolName），Web 上用 Lucide React 替代。
 * 覆盖 moduleCatalog（8 模块 + 48 主题）与 entryKindSymbolName 用到的全部
 * symbolName；未命中的兜底为 HelpCircle。
 */

import {
  Bug,
  Archive,
  ShoppingBasket,
  Building2,
  Calendar,
  Carrot,
  Sofa,
  BarChart3,
  ListChecks,
  Hexagon,
  Clock,
  CloudSun,
  Gem,
  FileClock,
  CircleDollarSign,
  Baby,
  PersonStanding,
  Fish,
  Flame,
  UtensilsCrossed,
  Shell,
  Settings2,
  Settings,
  Gift,
  Hammer,
  HeartHandshake,
  Heart,
  Home,
  Leaf,
  Map as MapIcon,
  MapPin,
  Mountain,
  PawPrint,
  Users,
  UsersRound,
  SquareStack,
  Shield,
  ShieldHalf,
  Package,
  Sparkles,
  Store,
  Sun,
  TreePine,
  Trophy,
  Wrench,
  Trees,
  HelpCircle,
  Leaf as LeafIcon,
  type LucideIcon,
} from 'lucide-react';

/** SF Symbol 名 → Lucide 组件。 */
const symbolMap: Record<string, LucideIcon> = {
  // 模块/主题图标
  'ant.fill': Bug,
  'archivebox.fill': Archive,
  'basket.fill': ShoppingBasket,
  'building.2.fill': Building2,
  calendar: Calendar,
  'carrot.fill': Carrot,
  'chair.lounge.fill': Sofa,
  'chart.bar.fill': BarChart3,
  checklist: ListChecks,
  'circle.hexagongrid.fill': Hexagon,
  'clock.fill': Clock,
  'cloud.sun.fill': CloudSun,
  'diamond.fill': Gem,
  'doc.badge.clock': FileClock,
  'dollarsign.circle.fill': CircleDollarSign,
  'figure.child': Baby,
  'figure.hiking': PersonStanding,
  'fish.fill': Fish,
  'flame.fill': Flame,
  'fork.knife': UtensilsCrossed,
  'fossil.shell.fill': Shell,
  'gearshape.2.fill': Settings2,
  'gearshape.fill': Settings,
  'gift.fill': Gift,
  'hammer.fill': Hammer,
  'heart.circle.fill': HeartHandshake,
  'heart.fill': Heart,
  'house.fill': Home,
  'leaf.circle.fill': LeafIcon,
  'leaf.fill': Leaf,
  'map.fill': MapIcon,
  'mappin.and.ellipse': MapPin,
  'mountain.2.fill': Mountain,
  'pawprint.fill': PawPrint,
  'person.2.fill': Users,
  'person.3.fill': UsersRound,
  'rectangle.on.rectangle': SquareStack,
  'shield.fill': Shield,
  'shield.lefthalf.filled': ShieldHalf,
  'shippingbox.fill': Package,
  sparkles: Sparkles,
  'storefront.fill': Store,
  'sun.haze.fill': Sun,
  'sun.max.fill': Sun,
  'tree.fill': TreePine,
  'trophy.fill': Trophy,
  'wrench.adjustable.fill': Wrench,
  'wrench.and.screwdriver.fill': Wrench,
  'trees': Trees,
};

/** 按 SF Symbol 名解析 Lucide 图标，未命中兜底 HelpCircle。 */
export function resolveSymbol(sfName: string): LucideIcon {
  return symbolMap[sfName] ?? HelpCircle;
}
